import gql from 'graphql-tag';

const key = `ListEnums`;
const query = gql`
  query ListRoleEnum {
    role: __type(name: "MemberRole") {
      enumValues {
        name
      }
    }
    employmentType: __type(name: "EmploymentType") {
      enumValues {
        name
      }
    }
    employmentStatus: __type(name: "EmploymentStatus") {
      enumValues {
        name
      }
    }
  }
`;

export const LIST_ENUMS = { key, query };
